export default __webpack_public_path__ + "static/media/home.867cdb6d.svg";